import styled, { css, keyframes } from 'styled-components'

import type { Snackbar } from './Provider'
import { SnackbarType } from './SnackbarType'

const fadeIn = css`
	animation: ${keyframes`
		from {
			transform: scale(0.8);
			margin-top: -60px;
			opacity: 0;
		}

		to {
			transform: scale(1);
			margin-top: 0;
			opacity: 1;
		}
	`} 0.3s;
`

const fadeOut = css`
	animation: ${keyframes`
		from {
			transform: scale(1);
			margin-top: 0;
			opacity: 1;
		}

		to {
			transform: scale(0.8);
			margin-top: -60px;
			opacity: 0;
		}
	`} 0.4s forwards;
`

const colors: Record<SnackbarType, string> = {
	[SnackbarType.Mute]: '#8F8F8F',
	[SnackbarType.Success]: '#5EB870',
	[SnackbarType.Warning]: '#ED6E0B',
	[SnackbarType.Error]: '#E15554',
}

type Props = {
	type: SnackbarType
	expired: boolean
}

export const DefaultSnackbar = styled.div<Props>`
	background-color: ${({ type }) => colors[type]};
	box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
	padding: 16px;
	margin-bottom: 8px;
	width: 100%;
	border-radius: 4px;
	color: #FFF;
	font-weight: 400;
	-webkit-font-smoothing: antialiased;
	transition: opacity 0.2s cubic-bezier(0, 0, 0.2, 1), transform 0.2s cubic-bezier(0, 0, 0.2, 1);

	${({ expired }) => (expired ? fadeOut : fadeIn)}
`

export const renderDefaultSnackbar = ({ message, type, expired }: Snackbar) => (
	<DefaultSnackbar type={type} expired={expired}>
		{message}
	</DefaultSnackbar>
)
